let stickyAdded = false;
window.addEventListener('scroll', function () {
    const header = document.querySelector('.header-wrapper');

    if (window.scrollY > 150 && !stickyAdded) {
        header.classList.add('sticky-nav');
        stickyAdded = true;
    } else if (window.scrollY <= 150 && stickyAdded) {
        header.classList.remove('sticky-nav');
        stickyAdded = false;
    }
});